module.exports = __webpack_public_path__ + "0ab9117e7f6adc008111dea838ea300d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/client/images/1-star.svg
// module id = 973
// module chunks = 0